'use client'

import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { type OpenableControls } from '../../generic-hooks'
import { useGlobalConfigContext } from '../../global-config'
import { TENANT } from '../../tenant'
import { type PersonalAdviceProduct } from '../PersonalAdviceProduct'

import { PersonalAdviceDialogWithoutAccordion } from './PersonalAdviceDialogWithoutAccordion'
import { PersonalAdviceDialogWithoutAccordionProvider } from './PersonalAdviceDialogWithoutAccordionContext'
import { DynamicPersonalAdviceDialogContent } from './ProductPersonalAdviceDialogContent/DynamicPersonalAdviceDialogContent'

export const PersonalAdviceDialog: FC<{
  dialogControls: OpenableControls
  product?: PersonalAdviceProduct
}> = ({ dialogControls, product }) => {
  const { tenant } = useGlobalConfigContext()
  const intl = useIntl()

  return tenant === TENANT.COM ? (
    <PersonalAdviceDialogWithoutAccordionProvider
      dialogControls={dialogControls}
      product={product}
    >
      <PersonalAdviceDialogWithoutAccordion />
    </PersonalAdviceDialogWithoutAccordionProvider>
  ) : (
    <Dialog onClose={dialogControls.handleClose} open={dialogControls.isOpen}>
      <DialogTitle
        onClose={dialogControls.handleClose}
        slotProps={{
          closeButton: {
            'aria-label': intl.formatMessage({
              id: 'general.link.label.close',
            }),
          },
        }}
      >
        <FormattedMessage id="buyBox.modal.advice.headline" />
      </DialogTitle>
      <DialogContent>
        <DynamicPersonalAdviceDialogContent product={product} />
      </DialogContent>
    </Dialog>
  )
}
